import React, { useCallback } from "react";
import type { AgGrid } from "@jsq/ds/core";
import { ExportButton as CsvExportButton } from "~/pages/Compliance/Common/ExportButton";
import { exportAllFilteredRows } from "../exportUtil";
import type { InvestmentEntitiesGraphqlDataSource } from "../investmentEntitiesGraphqlDataSource";

interface ExportButtonProps {
  gridApi: AgGrid.GridApi | null;
  dataSource: InvestmentEntitiesGraphqlDataSource | null;
}

const ExportButton: React.FC<ExportButtonProps> = ({ gridApi, dataSource }) => {
  const handleExport = useCallback(async () => {
    if (!gridApi || !dataSource) return;
    await exportAllFilteredRows(gridApi, dataSource);
  }, [gridApi, dataSource]);

  return (
    <CsvExportButton
      onExport={handleExport}
      disabled={!gridApi || !dataSource}
      testId="export-entities-button"
    />
  );
};

export default ExportButton;
